<div class="rs-panel-big rs-bg-c2">
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column rs-flex-shrink">
      <img
        alt=""
        src="{{
          'bills.redesign.overview.balanceCard.nothingToPay.nothingToPayWebImage'
            | translate
        }}"
        data-src="{{
          'bills.redesign.overview.balanceCard.nothingToPay.nothingToPayWebImage'
            | translate
        }}"
      />
    </div>
    <div class="rs-flex-column">
      <p class="rs-tit3 rs-padding-bottom1">
        {{
          'bills.redesign.overview.balanceCard.nothingToPay.paymentTextTitle'
            | translate
        }}
      </p>
      <p>
        {{
          (hasInstalmentPlan
            ? 'bills.redesign.overview.balanceCard.nothingToPay.ipActiveText'
            : 'bills.redesign.overview.balanceCard.nothingToPay.subPaymentText'
          ) | translate
        }}
      </p>
    </div>
  </div>
</div>
